import React from 'react'
import ResetLogo from '../../Assets/images/reset.png';
import OtpInput from 'react-otp-input';
import { resetPinValidation } from '../../Context/validation';
import { useFormik } from 'formik';
import axios from 'axios';
import { resetPinApi } from '../../Context/api';
import { statusCodes, commonMessage } from '../../Constants/generalConfig';
import { toast, ToastContainer } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import ValidationMessage from '../../Component/validationMessage';

const ResetPin = () => {
  const token = JSON.parse(localStorage.getItem('Token'));
  const email = JSON.parse(localStorage.getItem('email'))
  const navigate = useNavigate();
  const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

  const formik = useFormik({
    initialValues: {
      pin: '',
      confirmPin: '',
    },
    validationSchema: resetPinValidation,
    onSubmit: values => {
      formik.resetForm();
      const data = { password: formik.values.confirmPin, email: email, token: token, timeZone: timeZone }
      axios.post(resetPinApi(), { ...data }).then((resp) => {
        if (resp.data.code === statusCodes.ok) {
          toast.success(resp.data.message)
          setTimeout(() => { navigate('/') }, 2000)
        }
        else {
          toast.error(resp.data.message)
        }
      })
        .catch(() => {
          toast.error(commonMessage.networkError)

        })
    },
  });
  return (
    <>
      <ToastContainer />
      <section className="bg_img">
        <section>
          <div className="col-lg-12">
            <div className="container">
              <div className="col-lg-10 mx-auto">
                <div className="row" style={{ padding: '16% 0' }}>
                  <div
                    className="col-lg-6 bg_color border_reduas padd_img d-flex justify-content-center"
                  >
                    <img src={require('../../Assets/images/Reset_Pin.jpg')} className="border_reduas_2" alt="" />
                  </div>
                  <div className="col-lg-6 bg_white border_reduas_1 p-5">
                    <div className="ps-4 pt-5">
                      <h1 className="heading_color">Reset Pin</h1>
                      <p className="peragraf_color">
                        Set the New Pin for the Account so that you can Easily
                        Login and Use Features.
                      </p>
                      <div className="pt-4">
                        <div className="input-group mb-4 position-relative">
                          <span className="input-group-text" id="basic-addon1"
                          ><svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="32"
                            height="30"
                            viewBox="0 0 24 24"
                          >
                              <path
                                fill="#F47E3B"
                                d="M12 17a2 2 0 0 0 2-2a2 2 0 0 0-2-2a2 2 0 0 0-2 2a2 2 0 0 0 2 2m6-9a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V10a2 2 0 0 1 2-2h1V6a5 5 0 0 1 5-5a5 5 0 0 1 5 5v2zm-6-5a3 3 0 0 0-3 3v2h6V6a3 3 0 0 0-3-3"
                              />
                            </svg>
                          </span>
                          <input
                            type="password"
                            className="form-control form-control_Style"
                            name='pin'
                            value={formik.values.pin}
                            onChange={formik.handleChange}
                            maxLength={4}
                            onInput={(e) => { if (e.target.value.length > e.target.maxLength) e.target.value = e.target.value.slice(0, e.target.maxLength); }}
                          />
                          <ValidationMessage name='pin' formName={formik} />
                          {/* <span className="position_eye"
                          ><svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                          >
                              <path
                                fill="#F7A77A"
                                d="M11.83 9L15 12.16V12a3 3 0 0 0-3-3zm-4.3.8l1.55 1.55c-.05.21-.08.42-.08.65a3 3 0 0 0 3 3c.22 0 .44-.03.65-.08l1.55 1.55c-.67.33-1.41.53-2.2.53a5 5 0 0 1-5-5c0-.79.2-1.53.53-2.2M2 4.27l2.28 2.28l.45.45C3.08 8.3 1.78 10 1 12c1.73 4.39 6 7.5 11 7.5c1.55 0 3.03-.3 4.38-.84l.43.42L19.73 22L21 20.73L3.27 3M12 7a5 5 0 0 1 5 5c0 .64-.13 1.26-.36 1.82l2.93 2.93c1.5-1.25 2.7-2.89 3.43-4.75c-1.73-4.39-6-7.5-11-7.5c-1.4 0-2.74.25-4 .7l2.17 2.15C10.74 7.13 11.35 7 12 7"
                              /></svg
                            ></span> */}
                        </div>
                        <div className="input-group mb-4 mt-4 position-relative">
                          <span className="input-group-text" id="basic-addon1"
                          ><svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="32"
                            height="30"
                            viewBox="0 0 24 24"
                          >
                              <path
                                fill="#F47E3B"
                                d="M12 17a2 2 0 0 0 2-2a2 2 0 0 0-2-2a2 2 0 0 0-2 2a2 2 0 0 0 2 2m6-9a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V10a2 2 0 0 1 2-2h1V6a5 5 0 0 1 5-5a5 5 0 0 1 5 5v2zm-6-5a3 3 0 0 0-3 3v2h6V6a3 3 0 0 0-3-3"
                              />
                            </svg>
                          </span>
                          <input
                            type="password"
                            className="form-control form-control_Style"
                            placeholder="Confirm Pin"
                            name='confirmPin'
                            value={formik.values.confirmPin}
                            onChange={formik.handleChange}
                            maxLength={4}
                            onInput={(e) => { if (e.target.value.length > e.target.maxLength) e.target.value = e.target.value.slice(0, e.target.maxLength); }}
                          />
                          <ValidationMessage name='confirmPin' formName={formik} />
                          {/* <span className="position_eye"
                          ><svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                          >
                              <path
                                fill="#F7A77A"
                                d="M11.83 9L15 12.16V12a3 3 0 0 0-3-3zm-4.3.8l1.55 1.55c-.05.21-.08.42-.08.65a3 3 0 0 0 3 3c.22 0 .44-.03.65-.08l1.55 1.55c-.67.33-1.41.53-2.2.53a5 5 0 0 1-5-5c0-.79.2-1.53.53-2.2M2 4.27l2.28 2.28l.45.45C3.08 8.3 1.78 10 1 12c1.73 4.39 6 7.5 11 7.5c1.55 0 3.03-.3 4.38-.84l.43.42L19.73 22L21 20.73L3.27 3M12 7a5 5 0 0 1 5 5c0 .64-.13 1.26-.36 1.82l2.93 2.93c1.5-1.25 2.7-2.89 3.43-4.75c-1.73-4.39-6-7.5-11-7.5c-1.4 0-2.74.25-4 .7l2.17 2.15C10.74 7.13 11.35 7 12 7"
                              /></svg
                            ></span> */}
                        </div>
                        <div className="pt-4">
                          <button className="my_btn" onClick={formik.handleSubmit}>Submit</button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </section>
    </>
  )
}

export default ResetPin;